import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { CONTRACT_STATE_TEMPLATE_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetStateLawByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getStateLawById = async (id: string) =>
  await axiosAuth.get(`${CONTRACT_STATE_TEMPLATE_API}/${id}`);

const useGetStateLawById = ({id, queryParams}: UseGetStateLawByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["contract-state-law", id],
    queryFn: () => getStateLawById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetStateLawById;
